import React from 'react';
import { Button, Dialog, Flex, HelpText, Text, TextInput, createForm } from '@applyboard/crystal-ui';
import { ClockOutlineIcon } from '@applyboard/ui-icons';
import { COUNTDOWN_DURATION, obfuscatePhoneNumber } from "./utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field;
export function VerificationDialog(_ref) {
  var whatsappNumber = _ref.whatsappNumber,
    verificationState = _ref.verificationState,
    updateVerificationState = _ref.updateVerificationState,
    handleConfirmCode = _ref.handleConfirmCode,
    isVerifyingWhatsAppVerificationCode = _ref.isVerifyingWhatsAppVerificationCode,
    time = _ref.time,
    startTimer = _ref.startTimer,
    triggerWhatsAppVerificationCode = _ref.triggerWhatsAppVerificationCode,
    onVerificationComplete = _ref.onVerificationComplete;
  return _jsxs(Dialog, {
    open: verificationState.isVerificationDialogOpen,
    onOpenChange: function onOpenChange(open) {
      return updateVerificationState({
        isVerificationDialogOpen: open
      });
    },
    size: "md",
    children: [_jsx(Dialog.Heading, {
      children: "Verify WhatsApp number"
    }), _jsx(Dialog.Content, {
      children: _jsx(Form, {
        defaultValues: {
          verificationCode: verificationState.verificationCode
        },
        onSubmit: function onSubmit() {
          return handleConfirmCode(onVerificationComplete);
        },
        id: "verification-dialog-form",
        children: _jsxs(Flex, {
          direction: "column",
          gap: 8,
          children: [_jsx(Flex, {
            direction: "column",
            gap: 2,
            children: _jsxs(Text, {
              variant: "bodyM",
              children: ["Type the verification code you received at ", obfuscatePhoneNumber(whatsappNumber), ". It may take up to 2 minutes to get your code."]
            })
          }), _jsx(Field, {
            as: TextInput,
            name: "verificationCode",
            label: "Enter verification code",
            intent: verificationState.errorMessage ? 'negative' : 'secondary',
            helpText: verificationState.errorMessage,
            onChange: function onChange(value) {
              updateVerificationState({
                verificationCode: value,
                errorMessage: undefined
              });
            },
            placeholder: "Type code...",
            required: "Verification code is required"
          }), _jsxs(Flex, {
            direction: "column",
            gap: 4,
            children: [_jsxs(Flex, {
              direction: "column",
              gap: 2,
              children: [_jsx(Text, {
                variant: "labelM",
                intent: "secondary",
                contrast: "high",
                children: "Didn't receive the code?"
              }), _jsxs(Flex, {
                gap: 2,
                align: "center",
                children: [_jsx(Button, {
                  intent: "primary",
                  disabled: time !== 0,
                  emphasis: "highlighted",
                  size: "sm",
                  onClick: function onClick() {
                    if (time === 0) {
                      startTimer(COUNTDOWN_DURATION);
                    }
                    triggerWhatsAppVerificationCode();
                  },
                  children: time === 0 ? 'Send a new code' : 'Waiting for code'
                }), _jsx(Text, {
                  children: "|"
                }), _jsx(Button, {
                  intent: "primary",
                  emphasis: "highlighted",
                  size: "sm",
                  onClick: function onClick() {
                    updateVerificationState({
                      isVerificationDialogOpen: false,
                      isChangeNumberDialogOpen: true,
                      verificationCode: '',
                      errorMessage: undefined
                    });
                  },
                  children: "Change number"
                })]
              }), _jsxs(Flex, {
                direction: "row",
                gap: 2,
                children: [_jsx(ClockOutlineIcon, {
                  intent: "secondary"
                }), _jsxs(HelpText, {
                  intent: "secondary",
                  children: ["Please wait ", _jsxs("strong", {
                    children: [time, " seconds"]
                  }), " before sending a new code."]
                })]
              })]
            }), _jsx(HelpText, {
              intent: "secondary",
              children: "* Required information."
            })]
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        disabled: !verificationState.verificationCode,
        emphasis: "contained",
        form: "verification-dialog-form",
        intent: "primary",
        loading: isVerifyingWhatsAppVerificationCode,
        type: "submit",
        width: "fill",
        children: "Confirm code"
      })]
    })]
  });
}